<template>
	<section
		class="hero_header"
		:style="{'--content-bg': 'url(' + parsedImage.url + ')', '--quick-links-height': quick_links_height - (window.width < 1280 ? 140 : 0) + 'px'}"
	>
		<div class="container">
			<div class="content">

				<div class="text">
					<div class="inner">
						<h1
							v-if='title'
							:data-highlightword="getWordsInFirstRow(title)"
							v-html="title"
						></h1>
						<div
							v-if='description'
							class="body"
							v-html="description"
						></div>

						<div
							class='cta_container'
							v-if='parsedCta'
						>
							<secondary-button
								:label="parsedCta.title"
								:link="parsedCta"
								theme='reverse'
							></secondary-button>
						</div>
					</div>

					<div
						class='quicklinks'
						v-if='parsedQuickLinks'
						ref='quickLinks'
					>
						<div class='quicklinks__title'>
							<h6>Quicklinks</h6>
						</div>
						<quick-link
							v-for='(quicklink, index) in parsedQuickLinks'
							:key='index'
							:class="{'acc': window.width < 1280}"
							:quicklink="quicklink"
							@click="handleAccordionToggle"
						></quick-link>

					</div>

				</div>

				<div
					class='image'
					:style="{'--image-mask': 'url(' + imageMask + ')'}"
				>
					<img :src='parsedImage.url' />
				</div>

			</div>

		</div>

	</section>
</template>

<script>
import QuickLink from './QuickLink.vue';
import ImageMask from '../../images/mask.svg';
import SecondaryButton from './SecondaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			quick_links_height: {},
			imageMask: ImageMask,
		};
	},

	props: {
		title: {},
		description: {},
		call_to_action: {},
		image: {},
		quick_links: {},
	},

	computed: {
		parsedImage() {
			if (this.image) {
				return JSON.parse(this.image);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		parsedQuickLinks() {
			if (this.quick_links) {
				return JSON.parse(this.quick_links);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.getQuickLinksHeight();
		},

		handleAccordionToggle(isOpen) {
			console.log('Accordion state:', isOpen);
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}

			console.log('Quicklinks Height:', this.quick_links_height);
		},

		getQuickLinksHeight() {
			// Access the element via its ref
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: { QuickLink, SecondaryButton },

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.hero_header {
	background: var(--midnight);
	position: relative;

	svg {
		position: absolute;
		bottom: -24px;
		right: 24px;
		z-index: 5;

		@media (max-width: $mobile-xl) {
			display: none;
		}
	}

	@media (max-width: $mobile-xl) {
		background-position: left center;
		min-height: calc(100vh - 400px);
	}

	.container:first-of-type {
		min-height: 100%;
		position: relative;

		/* @media (min-width: $mobile-xl) {
			padding: 0 0 0 40px;
		} */

		@media (max-width: $mobile-xl) {
			min-height: calc(100vh - 400px);
		}
	}

	.content {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: var(--gutter-tablet-desktop);
		position: relative;
		z-index: 15;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
			grid-template-columns: repeat(4, 1fr);
			max-height: unset;
			align-items: flex-end;
			min-height: 315px;
		}

		.text {
			grid-column: 1 / span 6;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			gap: 32px;
			position: relative;
			z-index: 5;
			padding-top: 24px;
			padding-bottom: 24px;
			padding-right: 0;
			display: grid;
			grid-template-columns: repeat(6, 1fr);
			grid-template-rows: 1fr auto;

			@media (max-width: $mobile-xl) and (orientation: portrait) {
				grid-column: span 4;
				gap: 24px;
				/* height: 100%; */
				padding-top: 0;
				padding-bottom: 0;
				justify-content: flex-end;
				grid-template-columns: repeat(4, 1fr);
			}

			#breadcrumbs {
				top: 20px;
				position: absolute;

				.breadcrumb_container {
					> span {
						@media only screen and (max-width: 768px) {
							&:first-child a {
								text-indent: -9999px;
								color: var(--white);

								&::before {
									content: '…';
									text-indent: 0;
								}
							}
						}

						span {
							&.breadcrumb_last {
								color: var(--white);
							}

							a {
								font: normal normal normal 14px/20px var(--primary-font-family);
								color: var(--white);
							}

							strong {
								font: normal normal bold 14px/20px var(--primary-font-family);
								color: var(--white);
							}

							&.divider {
								&::before {
									margin: 0 10px;
									content: '/';
									color: var(--white);
								}
							}

							&:last-child {
								a {
									font: normal normal bold 14px/20px var(--primary-font-family);
								}
							}
						}
					}
				}
			}

			> .inner {
				grid-column: 2 / span 4;
				display: flex;
				flex-direction: column;
				justify-content: center;
				gap: 24px;

				@media (max-width: $mobile-xl) {
					grid-column: 1 / span 4;
				}

				h1 {
					color: var(--cobalt);
					margin: 0;

					&::first-line {
						color: var(--cobalt);
					}

					@media (max-width: $mobile-xl) {
						margin: 32px 0 0;
					}
				}

				.body {
					margin-top: 24px;

					@media (max-width: $mobile-xl) {
						margin-top: 0;
					}

					&::v-deep {
						p {
							color: var(--white);
							padding-right: 50px;
							margin: 0;
							font-size: 18px;
							font-style: normal;
							font-weight: 400;
							line-height: 24px; /* 133.333% */

							@media (max-width: $mobile-xl) {
								padding-right: unset;
							}
						}
					}
				}
			}

			.quicklinks {
				grid-column: span 6;
				display: grid;
				grid-template-columns: repeat(3, auto);
				padding: 0;
				gap: 32px;
				row-gap: 8px;

				&__title {
					grid-column: span 3;

					@media (max-width: $tablet) {
						grid-column: span 1;
						margin-bottom: 8px;
					}

					h6 {
						font-size: 14px;
						font-style: normal;
						font-weight: 700;
						line-height: 18px; /* 128.571% */
						letter-spacing: 0.4px;
						text-transform: uppercase;
						color: var(--cobalt);
						margin: 0;
						font-family: var(--primary-font-family);
					}
				}

				@media (max-width: $tablet) {
					grid-column: span 4;
					/* width: calc(100% - 48px); */
					padding: 0;
					grid-template-columns: unset;
					grid-template-rows: repeat(3, auto);
					row-gap: 0;
				}
			}
		}

		.image {
			grid-column: 7 / span 5;
			display: flex;
			flex-direction: column;
			justify-content: center;
			padding: 24px 0;
			position: relative;
			z-index: 4;

			@media (max-width: $mobile-xl) {
				/* border-top: var(--border); */
				border-left: unset;
				grid-column: span 4;
				/* position: absolute; */
				width: calc(100% + 40px);
				margin-left: -20px;
				margin-right: -20px;
				min-height: unset;
				padding: 16px 0 24px;
			}

			> img:not(.device) {
				width: 100%;
				height: 550px;
				object-fit: cover;
				object-position: top;
				-webkit-mask-image: var(--image-mask);
				mask-image: var(--image-mask);
				-webkit-mask-repeat: no-repeat;
				mask-repeat: no-repeat;
				mask-size: contain;
				mask-position: center center;

				@media (max-width: $mobile-xl) {
					height: calc(100vw * 1.15);
				}
			}
		}
	}
}
</style>
